import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import SearchAndResultsContainer from 'components/crm/home/SearchAndResultsContainer';
import CrmContactStore from 'stores/crm-opp-ui/CrmContactStore';
import CrmContactActions from 'actions/crm-opp-ui/CrmContactActions';

@connectToStores
class ContactSearch extends React.Component {
  constructor(props) {
    super(props);
    this.entityClick = this.entityClick.bind(this);
  }

  static getStores() {
    return [CrmContactStore];
  }

  static getPropsFromStores() {
    const store = CrmContactStore.getState();
    const contacts = store.searchResults || [];
    return {
      contacts: contacts,
      searchTerm: store.searchTerm,
      isSearching: store.isSearching,
    };
  }

  entityClick(entity) {
    this.props.selectEntity(entity);
    CrmContactActions.setSearchTerm(entity.name);
  }

  render() {
    const {
      autoFocus,
      contacts,
      searchTerm,
      entityLoaded,
      isSearching,
      placeholder = 'type name or email to search',
      className,
      searchDisabled = false,
    } = this.props;

    const filteredResults = this.props.filterResults
      ? this.props.filterResults(contacts)
      : contacts;

    return (
      <SearchAndResultsContainer
        autoFocus={autoFocus}
        placeholder={placeholder}
        executeSearch={CrmContactActions.searchContacts}
        tabIndex={3}
        searchResults={filteredResults}
        searchTerm={searchTerm}
        selectEntity={this.entityClick}
        entityLoaded={entityLoaded}
        isSearching={isSearching}
        className={className}
        searchDisabled={searchDisabled}
      />
    );
  }
}

export default ContactSearch;
